import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getTerritories } from '../../api/processingLabApi';
import { ApiStatus } from '../../api/apiStatus';

export interface ProcessingLabState {
  territories: string[];
  status: ApiStatus;
}

const initialState: ProcessingLabState = {
  territories: [],
  status: null
};

export const loadProcessingLab = createAsyncThunk(
  'processing-lab/territories',
  async () => {
    try {
      return await getTerritories();
    } catch {
      return {
        territories: [],
      };
    }
  }
);

export const processingLabSlice = createSlice({
  name: 'processingLab',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadProcessingLab.fulfilled, (state, action) => {
      state.territories = action.payload as string[]
      state.status = 'SUCCESS';
    }).addCase(loadProcessingLab.pending, (state) => {
      state.status = 'LOADING';
    }).addCase(loadProcessingLab.rejected, (state) => {
      state.status = 'FAILED';
    });
  },
});

export const selectTerritories = (state: RootState) =>
  state.processingLab.territories;

export const selectTerritoriesFetchStatus = (state: RootState) =>
  state.processingLab.status;

export default processingLabSlice.reducer;
